import React, { Component, PropTypes } from 'react';
import AppPage from 'components/AppPage';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import RestorePasswordForm from 'components/RestorePasswordForm';
import { Styles, Paper } from 'material-ui';
import { AuthActions } from 'actions';

const { Spacing } = Styles;

export default class ForgotPassword extends Component {
  static contextTypes = {
    muiTheme: PropTypes.object
  };

  submit(password, confirm) {
    const { key } = this.props.params;
    AuthActions.restorePassword(key, password, confirm);
  }

  render() {
    return (
      <AppPage
        style={{
          backgroundColor: 'transparent',
          backgroundImage: 'url(../images/library.jpg)',
          backgroundPosition: 'top left',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          marginTop: -Spacing.desktopKeylineIncrement,
          paddingTop: Spacing.desktopKeylineIncrement,
          boxSizing: 'initial'
        }}
      >
        <Paper
          zDepth={2}
          style={{
            backgroundColor: this.context.muiTheme.rawTheme.palette.cardColor,
            width: Spacing.desktopKeylineIncrement * 5 - 20,
            margin: 'auto',
            padding: Spacing.desktopGutterMini,
            paddingTop: Spacing.desktopGutter,
            paddingBottom: Spacing.desktopGutter,
            marginTop: Spacing.desktopKeylineIncrement
          }}
        >
          <RestorePasswordForm onSubmit={this.submit.bind(this)} />
        </Paper>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/RestorePassword.js